// @flow

/**
 * Navigation menu item
 */
import * as React from 'react';
import classnames from 'classnames';
import SvgInline from '@latitude/svg-inline';
// import { Link } from '@latitude/link';
import { Link } from '../Link/Link';
import type { MenuItemType } from './BaseHeader';
import './_menu-item.scss';

type Props = MenuItemType & {
  className?: string,
  active?: boolean, // Marks active menu item
  labelOnly?: boolean,
  onClick: (id: string) => void
};

class MenuItem extends React.Component<Props> {
  handleClick = () => this.props.onClick(this.props.id);

  render() {
    const {
      href,
      target,
      icon,
      label,
      bgGrey,
      labelBold,
      labelOnly,
      trackId,
    } = this.props;
    const className = classnames(
      'menu-item',
      this.props.className,
      { 'menu-item--bg-grey': bgGrey },
      { 'menu-item--label-bold': labelBold },
      { 'menu-item--label-only': labelOnly },
      { 'menu-item--indent-left-mobile': this.props.indentLeftMobile },
      { 'menu-item--desktop-only': this.props.desktopOnly },
      { 'menu-item--mobile-only': this.props.mobileOnly }
    );

    return (
      <div className={className}>
        {/* if only for label no need to track the data */}
        {labelOnly && (
          <a
            href={href}
            className="menu-item__button link--no-style trackcustomanalytics"
            onClick={this.handleClick}
            data-trackid={trackId}
            target={target}
          >
            {icon && (
              <SvgInline
                className="menu-item__icon"
                name={icon}
                strokeGreyDark
              />
            )}
            {label && <p className="menu-item__label">{label}</p>}
            <SvgInline className="menu-item__chevron" name="chevron-right" />
          </a>
        )}
        {!labelOnly && (
          <Link
            href={href}
            className="menu-item__button link--no-style trackcustomanalytics"
            onClick={this.handleClick}
            data-trackid={trackId}
            target={target}
            trackEventData={{
              label,
            }}
          >
            {icon && (
              <SvgInline
                className="menu-item__icon"
                name={icon}
                strokeGreyDark
              />
            )}

            {label && <p className="menu-item__label">{label}</p>}
            <SvgInline className="menu-item__chevron" name="chevron-right" />
          </Link>
        )}
      </div>
    );
  }
}

export default MenuItem;
